<template>
  <div class="table-widget">
    <table v-if="!loading_events && event_sessions.length > 0">
      <tr>
        <th>Event name</th>
        <th>USSD Code</th>
        <th>Start Date</th>
        <th>End Date</th>
        <th>Location</th>
        <th>Status</th>
        <th></th>
      </tr>
      <tr v-for="(item, index) in event_sessions" :key="index">
        <td>
          <div class="event-info">
            <h6>{{ item.title }}</h6>
          </div>
        </td>
        <td>
          <div class="event-date">{{ getEventUssd(item) }}</div>
        </td>
        <td>
          <div class="event-date">
            {{ item.startTime ? moment(item.startTime).format("DD MMM YYYY H:mm:ss") : "Not Set" }}
          </div>
        </td>
        <td>
          <div class="event-date">
            {{ item.endTime ? moment(item.endTime).format("DD MMM YYYY H:mm:ss") : "Not Set" }}
          </div>
        </td>
        <td>
          <div class="event-date">{{ item.venue || item.location || "-" }}</div>
        </td>
        <td>
          <div class="event-status">
            <b-tag v-if="item.status == 'public'" type="is-success" class="status-tag">Public</b-tag>
            <b-tag v-else-if="item.status == 'private'" type="is-info" class="status-tag">Private</b-tag>
            <b-tag v-else type="is-default" class="status-tag">{{ item.status }}</b-tag>
          </div>
        </td>
        <td>
          <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
            <template #trigger>
              <b-icon icon="dots-vertical"></b-icon>
            </template>
            <b-dropdown-item @click="openUpdateUssdModal(item)" aria-role="listitem">Update Ticket USSD</b-dropdown-item>
            <b-dropdown-item @click="deleteEventSession(item)" aria-role="listitem">Delete</b-dropdown-item>
          </b-dropdown>
        </td>
      </tr>
    </table>
    <table v-if="loading_events">
      <tr>
        <th>Event name</th>
        <th>USSD Code</th>
        <th>Start Date</th>
        <th>End Date</th>
        <th>Location</th>
        <th>Status</th>
        <th></th>
      </tr>
      <tr v-for="(item, index) in 15" :key="index">
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
      </tr>
    </table>
    <widgetNotfound v-if="!loading_events && event_sessions.length === 0" title="No ticket events found"
      subtitle="This partner has no ticket events yet. Live streams are listed under Streaming.">
    </widgetNotfound>

    <UpdateEventUssdModal ref="updateUssdModal" :partner="partner" @success="getAllEvents">
    </UpdateEventUssdModal>
  </div>
</template>
<script>
import UpdateEventUssdModal from "./UpdateEventUssdModal.vue";

export default {
  components: {
    UpdateEventUssdModal,
  },
  props: {
    partner: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    event_sessions: [],
    loading_events: false,
  }),
  mounted() {
    this.getAllEvents();
  },
  methods: {
    getEventUssd(event) {
      if (event.customUssd) return event.customUssd;
      return `*550*2*2*${event.id}#`;
    },
    openUpdateUssdModal(item) {
      this.$refs.updateUssdModal.openModal(item);
    },
    getAllEvents() {
      let vm = this;
      vm.loading_events = true;
      vm.$store
        .dispatch("EVENTS_GET_ALL_EVENT", { user_id: vm.partner.id })
        .then((response) => {
          vm.loading_events = false;
          vm.event_sessions = response.data || [];
        })
        .catch(() => {
          vm.loading_events = false;
          vm.event_sessions = [];
        });
    },
    deleteEventSession(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Delete Event",
        message: "Are you sure you want to <b>delete</b> this event? This action cannot be undone.",
        confirmText: "Delete Event",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("EVENTS_DELETE_EVENT", {
              id: item.id,
              user_id: vm.partner.id,
            })
            .then((response) => {
              vm.getAllEvents();
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
            })
            .catch(() => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Error",
                text: "Failed to delete event. Please try again.",
              });
            });
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.table-widget {
  overflow-y: auto;
  border-radius: 0;

  table {
    width: 100%;

    tr {
      th {
        white-space: nowrap;
      }

      td {
        white-space: nowrap;
      }
    }
  }
}
</style>
